/* Kaylah Cosmetics - shared section behaviour
   Loaded once per page. Safe to include multiple times. */
(function () {
  if (window.__kaylahInit) return;
  window.__kaylahInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduce) document.documentElement.classList.add('k-anim');

  /* ---------- scroll reveal ---------- */
  var io = null;
  if ('IntersectionObserver' in window && !reduce) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
  }

  function initReveal(root) {
    var els = root.querySelectorAll('[data-k-reveal]:not(.is-in)');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.style.transitionDelay = (Math.min(i, 6) * 80) + 'ms';
      if (io) io.observe(el); else el.classList.add('is-in');
    }
  }

  /* ---------- accordions ---------- */
  function closePanel(btn, panel) {
    panel.style.height = panel.scrollHeight + 'px';
    requestAnimationFrame(function () { panel.style.height = '0px'; });
    btn.setAttribute('aria-expanded', 'false');
  }

  function openPanel(btn, panel) {
    panel.style.height = panel.scrollHeight + 'px';
    btn.setAttribute('aria-expanded', 'true');
    var done = function () {
      panel.style.height = 'auto';
      panel.removeEventListener('transitionend', done);
    };
    if (reduce) done(); else panel.addEventListener('transitionend', done);
  }

  function initAccordions(root) {
    var accs = root.querySelectorAll('[data-k-acc]');
    accs.forEach(function (acc) {
      if (acc.dataset.kReady) return;
      acc.dataset.kReady = '1';
      var single = acc.dataset.kAcc === 'single';
      acc.querySelectorAll('[data-k-acc-btn]').forEach(function (btn) {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        if (btn.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
        btn.addEventListener('click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          if (single && !isOpen) {
            acc.querySelectorAll('[data-k-acc-btn][aria-expanded="true"]').forEach(function (other) {
              var op = document.getElementById(other.getAttribute('aria-controls'));
              if (op) closePanel(other, op);
            });
          }
          if (isOpen) closePanel(btn, panel); else openPanel(btn, panel);
        });
      });
    });
  }

  /* ---------- before / after ---------- */
  function initBeforeAfter(root) {
    root.querySelectorAll('[data-k-ba]').forEach(function (ba) {
      if (ba.dataset.kReady) return;
      ba.dataset.kReady = '1';
      var grip = ba.querySelector('[data-k-ba-grip]');
      if (!grip) return;
      var dragging = false;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        ba.style.setProperty('--k-pos', pct + '%');
        grip.setAttribute('aria-valuenow', Math.round(pct));
      }

      function fromEvent(ev) {
        var rect = ba.getBoundingClientRect();
        var x = (ev.touches ? ev.touches[0].clientX : ev.clientX) - rect.left;
        setPos((x / rect.width) * 100);
      }

      function start(ev) { dragging = true; ba.classList.add('is-active'); fromEvent(ev); }
      function move(ev) { if (!dragging) return; fromEvent(ev); }
      function end() { dragging = false; ba.classList.remove('is-active'); }

      ba.addEventListener('mousedown', start);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', end);
      ba.addEventListener('touchstart', start, { passive: true });
      ba.addEventListener('touchmove', move, { passive: true });
      ba.addEventListener('touchend', end);
      ba.addEventListener('click', fromEvent);

      grip.addEventListener('keydown', function (ev) {
        var cur = parseFloat(grip.getAttribute('aria-valuenow') || '50');
        if (ev.key === 'ArrowLeft') { setPos(cur - 4); ev.preventDefault(); }
        if (ev.key === 'ArrowRight') { setPos(cur + 4); ev.preventDefault(); }
        if (ev.key === 'Home') { setPos(0); ev.preventDefault(); }
        if (ev.key === 'End') { setPos(100); ev.preventDefault(); }
      });
    });
  }

  /* ---------- hero video ---------- */
  function initHeroVideo(root) {
    root.querySelectorAll('[data-k-hero-video]').forEach(function (v) {
      if (v.dataset.kReady) return;
      v.dataset.kReady = '1';
      var ready = function () { v.classList.add('is-ready'); };
      if (v.readyState >= 3) ready(); else v.addEventListener('canplaythrough', ready, { once: true });
      v.addEventListener('loadeddata', ready, { once: true });
      var p = v.play();
      if (p && p.catch) p.catch(function () { ready(); });
    });
  }

  /* ---------- click-to-play media cards ---------- */
  function initPlay(root) {
    root.querySelectorAll('[data-k-play]').forEach(function (btn) {
      if (btn.dataset.kReady) return;
      btn.dataset.kReady = '1';
      btn.addEventListener('click', function () {
        var vid = btn.querySelector('video');
        if (!vid) return;
        if (vid.paused) { vid.muted = false; vid.play(); btn.classList.add('is-playing'); }
        else { vid.pause(); btn.classList.remove('is-playing'); }
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initReveal(root);
    initAccordions(root);
    initBeforeAfter(root);
    initHeroVideo(root);
    initPlay(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
})();
